const fontWeights = {
    core: {
        thin: 100,
        extraLight: 200,
        light: 300,
        regular: 400,
        medium: 500,
        demiBold: 600,
        bold: 700,
        extraBold: 800,
        black: 900,
        thinItalic: 100,
        xlightItalic: 200,
        lightItalic: 300,
        italic: 400,
        mediumItalic: 500,
        demiBoldItalic: 600,
        BoldItalic: 700,
        xboldItalic: 800,
        blackItalic: 900,
    },
};
export default fontWeights;
//# sourceMappingURL=fontWeights.js.map